import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { AsyncTypeahead } from 'react-bootstrap-typeahead'
import { Form, Button, Row, Col, Table } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import axios from 'axios'
import Message from '../components/Message'

import Loader from '../components/Loader'
import FormContainer from '../components/FormContainer'
import { register } from '../actions/userActions'

const RegisterScreen = ({ location, history }) => {

  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [password, setPassword] =useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [message, setMessage] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const [mesta, setMesta] = useState([])
  const [selectedMesta, setSelectedMesta] = useState([])

  const dispatch = useDispatch()

  const userRegister = useSelector(state => state.userRegister)

  const { loading, error, userInfo} = userRegister

  const redirect = location.search ? location.search.split('=')[1] : '/'

/*   useEffect(() => {
    if (userInfo) {
 //     history.push(redirect)
    }
  }, [history, userInfo, redirect]) */


  const searchHandler = (query) => {
    setIsLoading(true)

    axios.get(`/api/mesta/?abr=${query}`).then(item => {
      setMesta(item.data)
      setIsLoading(false)
    })

  } 

  const filterBy = () => true

  const deleteHandler = (id) => {
    setSelectedMesta(selectedMesta.filter(m => m._id !== id))
  }
  
  const submitHandler = (e) => {
    e.preventDefault()
    if (password !== confirmPassword) {
      setMessage('Passwords do not match')
    } else {
      dispatch(register(name, email, password, selectedMesta.map(mes=>mes._id)))
    }
    
  }

  return (
    <FormContainer>
      <h1>Kreiraj korisnika</h1>
      {message && <Message variant='danger'>{message}</Message>}
      {error && <Message variant='danger'>{error}</Message>}
      {loading && <Loader />}
      <Form onSubmit={submitHandler}>
      <Form.Group controlId='name'>
          <Form.Label>Name</Form.Label>
          <Form.Control type='name' placeholder='Enter name' value={name}
          onChange={(e) => setName(e.target.value)}></Form.Control>
        </Form.Group>
        <Form.Group controlId='email'>
          <Form.Label>Email Address</Form.Label>
          <Form.Control type='email' placeholder='Enter email' value={email}
          onChange={(e) => setEmail(e.target.value)}></Form.Control>
        </Form.Group>
        <Form.Group controlId='password'>
          <Form.Label>Password</Form.Label>
          <Form.Control type='password' placeholder='Enter password' value={password}
          onChange={(e) => setPassword(e.target.value)}></Form.Control>
        </Form.Group>
        <Form.Group controlId='confirmPassword'>
          <Form.Label>Confirm Password</Form.Label>
          <Form.Control type='password' placeholder='Confirm password' value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}></Form.Control>
        </Form.Group>
        <Form.Group controlId='selectTown'>
          <Form.Label>Izaberi grad</Form.Label>
          <AsyncTypeahead 
      filterBy={filterBy}
      id='basic-example' 
      labelKey='naziv'
      isLoading={isLoading}
      minLength={3}
      onSearch={searchHandler}
      options={mesta}
      placeholder='Izaberi grad'
      renderMenuItemChildren={(mesto) => (
        <div onClick={() => {
          setSelectedMesta([...selectedMesta, !selectedMesta.some(mes => mes._id === mesto._id) && mesto])
        }}>
        <span>{mesto.naziv}</span>
        </div>
        
      )}
      />
        </Form.Group>
           {!(selectedMesta.length === 0) && <Table striped bordered hover responsive className='table-sm'>
           <thead>
             <tr>
               <th>Grad</th>
             </tr>
           </thead>
           <tbody>
             {selectedMesta.map(mesto => (
             <tr key={mesto._id}>
                 <td>{mesto.naziv}</td>
                 <td>

                 <Button variant='danger' className='btn-sm right-aligned' onClick={() => deleteHandler(mesto._id)} >
                   <i className='fas fa-trash'>X</i>
                 </Button>
                 </td>
              </tr>
               ))}
           </tbody>
         </Table>}
        <Button type='submit' variant='primary'>
          Register
        </Button>
      </Form>
      <Row className='py-3'>
        <Col>
        Have account?{' '}
        <Link to={redirect ? `/login?redirect=${redirect}` : '/login'}>
          Login
        </Link>
        </Col>
      </Row>
    </FormContainer>
  )
}

export default RegisterScreen
